<template>
  <!-- 设置抽签方式 - 弹出框 -->
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.visible"
    append-to-body
    modal-append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    width="500px"
    v-loading="loading"
  >
    <div class="dialog-content">
      <el-form :disabled="view" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="tbdwIds">
          <el-select v-model="ruleForm.tbdwIds" placeholder="请选择抽签编号" multiple :multiple-limit="multipldLimit">
            <el-option
              v-for="(item, index) in enterpriseList"
              :key="item.tbdwId"
              :label="`${index + 1}(${item.tbdwName})`"
              :value="item.tbdwId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="!view" type="primary" @click="handleSubmit">确 定</el-button>
      <el-button v-else type="primary" @click="close">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DrawTypeDialog',

  props: {
    drawLimit: {
      type: Number,
      default: 0
    },

    view: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: {
        title: '抽签结果',
        visible: false,
      },

      ruleForm: {
        tbdwIds: [] // 已选回显企业
      },

      rules: {
        tbdwIds: [
          { required: true, message: '请选择抽签编号', trigger: 'blur' },
        ],
      },

      loading: false,

      enterpriseList: [], // 待选企业列表
      multipldLimit: 0 // 可选个数限制
    }
  },

  methods: {
    open() {
      this.getDrawDetail()
      this.dialog.visible = true
      this.dialog.title = `${this.view ? '查看' : '录入'}抽签结果`
    },

    close() {
      this.ruleForm.tbdwIds = []
      this.dialog.visible = false
    },

    valid() {
      let valid = false
      this.$refs.ruleForm.validate(v => valid = v)
      return valid
    },

    async handleSubmit() {
      if (!this.valid()) return

      try {
        this.loading = true
        const res = await this.$api.doDrawOffline(this.ruleForm.tbdwIds)
        if (!res.data.meta.success) {
          throw new Error(res.data.meta.message)
        }
        this.$message({
          type: "success",
          message: '录入抽签结果成功！',
        })
        this.$emit('success', this.ruleForm)
      } catch(err) {
        console.error('doDrawOffline fail', err)
        this.$message({
          type: "error",
          message: err.message || "请求失败，请稍后重试~",
        });
      } finally {
        this.loading = false
      }
    },

    async getDrawDetail() {
      try {
        const res = await this.$api.getDrawDetail();
        if (!res.data.meta?.success) throw new Error(res.data.meta.message)
        const { zqRecordList = [], drawRecordList = [] } = res?.data?.data || {}
        this.enterpriseList = drawRecordList
        this.ruleForm.tbdwIds = zqRecordList?.map(item => item.tbdwId) || []
        this.multipldLimit = this.drawLimit ? this.drawLimit : drawRecordList.length - 1
      } catch (err) {
        console.error('getDrawDetail fail', err)
        this.$message({
          type: "error",
          message: err.message || "请求失败，请稍后重试~",
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-select {
  width: 50%;
  margin: 0 25%;
}
</style>